import axios from 'axios';
import { CalculateNutrientInput } from 'views/feed-management/features/manual-feeds/types/calculate-nutrients-input.type';
import { CalculateNutrientsResult } from 'views/feed-management/features/manual-feeds/types/calculate-nutrients-result.type';

// POST
// ewosapi/v1/feeds/manual/nutrients
export const postCalculateNutrients = async (
  request: CalculateNutrientInput,
  manualFeedId: string
): Promise<CalculateNutrientsResult> => {
  const res = await axios.post<CalculateNutrientsResult>(`ewosapi/v1/feeds/manual/nutrients?manualFeedId=${manualFeedId}`, request);
  return res.data;
};
